import { API_URL } from '../constants/config';
import request from './request';

export function sendFeedback(data) {
  return request(`${API_URL}/orders/create`, {
    body: JSON.stringify(data),
    method: 'POST'
  });
}



// WEBPACK FOOTER //
// ./src/services/apiClient.js